<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您的測試記錄將不會被保留。" content_2="是否確認退出測試？"></QuitButton>
      <BackButton v-if="show_back_button" @click="goBack"></BackButton>
      <button v-if="isDebugMode && voice_play" class="debug-fast-forward" @click="debugFastForwardAudio">
        加速音頻
      </button>
    </FabColumn>

    <!-- todo 限制時間-->
    <ion-content class="content" :scroll-y="clock_scroll_enabled" :force-overscroll="false">
      <div class="test-box">
        <audio id="audio" style="display: none;"></audio>
        <div v-if="quiz_show_1001">
          <TestDescription :data="quiz_desc_1001"></TestDescription>
          <div class="img-box">
            <TestTrumpetStart v-show="voice_play" class="trumpet"></TestTrumpetStart>
            <TestTrumpetStop v-show="!voice_play" class="trumpet" @playVoice="playVoice"></TestTrumpetStop>
          </div>
          <TestConfirmTips v-if="!voice_play" class="confirmTips"></TestConfirmTips>
        </div>

        <div v-if="quiz_show_1002">
          <TestQuizNumber class="quizNumber" :number="quiz_number" :voice_play="voice_play" @playVoice="playVoice"></TestQuizNumber>
          <TestDescription :data="quiz_desc_1002"></TestDescription>
          <div class="img-box">
            <TestTick class="tick" v-if="!voice_play" @showConfirmBtn="showConfirmBtn" @getAnswer="getAnswer" @addActionSequence="addActionSequence" :record_initial_time="record_initial_time"></TestTick>
          </div>
        </div>

        <div v-if="quiz_show_1003">
          <TestQuizNumber class="quizNumber" :number="quiz_number" :voice_play="voice_play" @playVoice="playVoice"></TestQuizNumber>
          <TestDescription :data="quiz_desc_1003"></TestDescription>
          <div class="img-box">
            <TestHearStart  v-if="voice_play" class="hear"></TestHearStart>
            <TestHearStop v-if="!voice_play" class="hear"></TestHearStop>
          </div>
          <TestConfirmTips v-if="!voice_play || words_confirm_tips_show || story_confirm_tips_show" :text="confirm_tips_text" class="confirmTips"></TestConfirmTips>
        </div>
        <div v-if="quiz_show_1005">
          <TestQuizNumber class="quizNumber" :number="quiz_number" :voice_play="voice_play" @playVoice="playVoice"></TestQuizNumber>
          <TestDescription :data="quiz_desc_1005"></TestDescription>
          <div class="img-box">
            <TestMicStart v-if="voice_play" class="mic"></TestMicStart>
            <TestMicStop v-if="!voice_play" class="mic"></TestMicStop>
          </div>
          <TestConfirmTips v-if="!voice_play" class="confirmTips" text="現在可以讀出詞語"></TestConfirmTips>
        </div>
        <div v-if="quiz_show_1006">
          <TestQuizNumber class="quizNumber" :number="quiz_number" :voice_play="voice_play" @playVoice="playVoice"></TestQuizNumber>
          <TestDescription :data="quiz_desc_1006"></TestDescription>
          <TestClock v-if="!voice_play" @clock-drag-start="disableClockScroll" @clock-drag-end="enableClockScroll" @moveClock="moveClock" @getAnswer="getAnswer" @addActionSequence="addActionSequence" :record_initial_time="record_initial_time"></TestClock>
        </div>
        <div v-if="quiz_show_1007">
          <TestQuizNumber class="quizNumber" :number="quiz_number" :voice_play="voice_play" @playVoice="playVoice"></TestQuizNumber>
          <TestDescription :data="quiz_desc_1007"></TestDescription>
          <TestOption :options="quiz_options_1007" :voice_play="voice_play" @selectStoryOption="selectStoryOption" @getAnswer="getAnswer"  @addActionSequence="addActionSequence" :record_initial_time="record_initial_time" ref="story_option"></TestOption>
        </div>

        <div v-if="quiz_show_1008">
          <TestQuizNumber class="quizNumber" :number="quiz_number" :voice_play="voice_play" @playVoice="playVoice"></TestQuizNumber>
          <TestDescription :data="quiz_desc_1008"></TestDescription>
          <TestWordOption :options="quiz_options_1008" :voice_play="voice_play" @selectWordOption="selectWordOption" @getAnswer="getAnswer" @addActionSequence="addActionSequence" :record_initial_time="record_initial_time"></TestWordOption>
        </div>

        <div v-if="quiz_show_1009">
          <TestQuizNumber class="quizNumber" :number="quiz_number" :voice_play="voice_play" @playVoice="playVoice"></TestQuizNumber>
          <TestDescription :data="quiz_desc_1009"></TestDescription>
          <TestDescription v-if="!voice_play" :data="current_word_item"></TestDescription>
          <div class="img-box" v-if="!voice_play">
            <TestTick class="tick" @showConfirmBtn="showConfirmBtn" ref="word_tick" @getAnswer="getWordAnswer" @addActionSequence="addActionSequence" :record_initial_time="record_initial_time"></TestTick>
          </div>
        </div>
        <div v-if="show_confirm_btn && !voice_play" class="test-confirm-button">
          <ConfirmButton v-if="quiz_show_1009" position="relative" @click="nextWordOption"></ConfirmButton>
          <ConfirmButton v-else-if="quiz_show_1008" position="relative" @click="nextQuestion(true, true)"></ConfirmButton>
          <ConfirmButton v-else position="relative" @click="nextQuestion(true)"></ConfirmButton>
        </div>
        <TestNumber :number="user_info.number"></TestNumber>
      </div>

    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage, isPlatform} from "@ionic/vue";
import Background from "../components/common/Background";
import TestNumber from "../components/test/TestNumber";
import TestDescription from "../components/test/TestDescription";
import TestTrumpetStart from "../components/test/TestTrumpetStart";
import TestTrumpetStop from "../components/test/TestTrumpetStop";
import TestConfirmTips from "../components/test/TestConfirmTips";
import TestQuizNumber from "../components/test/TestQuizNumber";
import TestTick from "../components/test/TestTick";
import TestClock from "../components/test/TestClock";
import TestOption from "../components/test/TestOption";
import TestWordOption from "../components/test/TestWordOption";
import ConfirmButton from "../components/common/ConfirmButton";
import WhiteBackground from "../components/common/WhiteBackground";
import common from "../common";
import QuitButton from "../components/common/QuitButton";
import TestHearStart from "../components/test/TestHearStart";
import TestHearStop from "../components/test/TestHearStop";
import TestMicStart from "../components/test/TestMicStart";
import TestMicStop from "../components/test/TestMicStop";
import router from "../router";
import BackButton from "../components/common/BackButton";
import {Media, MediaObject} from "@awesome-cordova-plugins/media";
import {File} from "@awesome-cordova-plugins/file";
import {Device} from "@capacitor/device";
import { requestMicrophoneStream } from '@/utils/microphonePermission';

export default {
  name: "Test",
  components: {
    BackButton,
    TestMicStop,
    TestMicStart,
    TestHearStop,
    TestHearStart,
    QuitButton,
    WhiteBackground,
    ConfirmButton,
    TestWordOption,
    TestOption,
    TestClock,
    TestTick,
    TestQuizNumber,
    TestConfirmTips,
    TestTrumpetStop,
    TestTrumpetStart,
    TestDescription,
    TestNumber,
    Background,
    IonPage,
    IonContent
  },
  data() {
    return {
      user_info: {},
      questions: null,
      test_id: 0,
      words: null,
      test_words: null,
      current_question_id: 0,
      current_question_index: null,
      current_question_type: null,
      current_question_record_type: null,
      current_question_time: 0,
      startTime: 0,
      endTime: 0,
      current_question_time_inter: null,
      current_voice: 0,
      audio: null,
      audioEndedHandler: null,
      audioErrorHandler: null,
      audioPlaybackId: 0,
      voice_play: false,
      show_confirm_btn: false,
      words_voice: [],
      words_confirm_tips_show: false,
      words_option: [],
      current_word_index: 0,
      current_word_item: null,
      current_word_option: [],
      option_voice: null,
      confirm_tips_text: '如果明白請按「確定」',
      confirm_tips: [
          '如果明白請按「確定」',
          '請細心聆聽',
          '現在可以讀出詞語'
      ],
      story_confirm_tips_show: false,

      quiz_number: '',
      quiz_show_1001: true,
      quiz_desc_1001: '',
      quiz_show_1002: false,
      quiz_desc_1002: '',
      quiz_show_1003: false,
      quiz_desc_1003: '',
      quiz_show_1005: false,
      quiz_desc_1005: '',
      quiz_show_1006: false,
      quiz_desc_1006: '',
      quiz_show_1007: false,
      quiz_desc_1007: '',
      quiz_options_1007: [],
      quiz_show_1008: false,
      quiz_desc_1008: '',
      quiz_options_1008: [],
      quiz_show_1009: false,
      quiz_desc_1009: '',

      current_answer: null,
      answers: [],
      show_back_button: false,
      media: null,
      record_file: {},
      play_timeout: null,
      is_literate: true,

      record_initial_time: 0,
      record_question_start_time: 0,
      record_confirm_ready_time: 0,
      record_confirm_coordinate: '',
      record_action_sequence: [],
      test_record: [],
      clock_scroll_enabled: true,

      // 瀏覽器錄音相關
      mediaRecorder: null,
      audioChunks: [],
      recordStartTime: 0,
    }
  },
  ionViewWillEnter() {
    document.body.classList.add('ecs-test-route');
    common.initData(this);
    common.getUserInfo().then(user_info => {
      this.user_info = user_info;
    })

    common.getStorage('test_data').then(res => {
      this.questions = res.questions;
      this.test_id = res.test_id;
      this.words = res.words;
      this.test_words = res.test_words;
      this.words_option = res.words_option;
      this.current_word_item = res.words_option[0].item;

      for (const i in res.test_words) {
        this.words_voice.push(this.getWordVoice(res.test_words[i]))
      }

      this.current_question_index = 0;
      this.showQuestion(this.current_question_index);
    })

  },
  ionViewDidEnter() {
    this.record_initial_time = this.initialRecordTime();
    window.addEventListener('beforeunload', this.confirmLeave);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  ionViewWillLeave() {
    document.body.classList.remove('ecs-test-route');
    this.stopAudioPlayback();

    // 清理錄音
    this.stopRecord();
    if (this.mediaRecorder) {
      this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
      this.mediaRecorder = null;
    }

    if (this.play_timeout) {
      clearTimeout(this.play_timeout);
      this.play_timeout = null;
    }

    window.removeEventListener('beforeunload', this.confirmLeave);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  computed: {
    isDebugMode: function () {
      return common.config.debug === true && !isPlatform('hybrid');
    },
  },
  methods: {
    showQuestion: function (index) {
      this.hideAllQuestion();
      const question = this.questions[index];

      if (question === undefined) {
        this.goTestFinish()
        return
      }
      this.record_question_start_time = this.record_initial_time ? this.getCurrentTime() : 0;

      this.show_back_button = question.can_back;
      this.current_question_id = question.id;
      this.current_question_type = question.type;
      this.current_question_record_type = question.record_type;
      this.stopRecord();
      this.stopAudioPlayback(false);

      if (question.type === 1004) {
        this.playWord();
      } else {
        this.current_voice = common.getVoice(question.resource_id);
        this.playVoice();
      }

      this.quiz_number = question.number;

      if (question.type === 1001) {
        this.quiz_show_1001 = true;
        this.quiz_desc_1001 = question.description;
      } else if (question.type === 1002) {
        this.quiz_show_1002 = true;
        this.quiz_desc_1002 = question.description;
      } else if (question.type === 1003 || question.type === 1004 || question.type === 1010) {
        this.quiz_show_1003 = true;
        this.quiz_desc_1003 = question.description;
      } else if (question.type === 1005) {
        this.quiz_show_1005 = true;
        this.quiz_desc_1005 = question.description;
      } else if (question.type === 1006) {
        this.quiz_show_1006 = true;
        this.quiz_desc_1006 = question.description;
      } else if (question.type === 1007) {
        this.quiz_show_1007 = true;
        this.quiz_desc_1007 = question.description;
        this.quiz_options_1007 = question.option;
      } else if (question.type === 1008) {
        this.quiz_show_1008 = true;
        this.quiz_desc_1008 = question.description;
        this.quiz_options_1008 = this.words_option;
      } else if (question.type === 1009) {
        this.quiz_show_1009 = true;
        this.quiz_desc_1009 = question.description;
      }
    },
    hideAllQuestion: function () {
      this.quiz_show_1001
          = this.quiz_show_1002
          = this.quiz_show_1003
          = this.quiz_show_1005
          = this.quiz_show_1006
          = this.quiz_show_1007
          = this.quiz_show_1008
          = this.quiz_show_1009
          = false;
    },
    nextQuestion: async function (is_click_confirm = false, add_confirm_record = false) {
      if (is_click_confirm === true) {
        this.record_confirm_coordinate = event.x * window.devicePixelRatio + ',' + event.y * window.devicePixelRatio;
      }

      if (add_confirm_record === true) {
        this.addConfirmRecord();
      }

      this.addTestRecord(this.current_question_record_type, this.current_answer);

      if (this.current_question_time_inter) {
        clearInterval(this.current_question_time_inter);
      }

      if (this.checkHasAnswer(this.current_question_type)) {
        this.endTime = performance.now();
        const operationTime = Math.floor(this.endTime - this.startTime);
        // console.log(`回答时间: ${operationTime} 毫秒`);
        this.answers.push({
          test_id: this.test_id,
          question_id: this.current_question_id,
          type: this.current_question_type,
          answer: this.current_answer,
          operation_time: operationTime,
        })
      }

      // 錄音文件
      if (this.current_question_type === 1005) {
        if (!isPlatform('hybrid')) {
          // 瀏覽器：直接獲取 Blob
          const audioBlob = await this.stopRecordWeb();
          if (audioBlob) {
            this.record_file[this.current_answer] = audioBlob;
          }
        } else {
          // 移動端：使用 File 插件
          this.stopRecord();
          const path = File.externalDataDirectory || File.dataDirectory;
          const file = this.current_answer;
          try {
            File.checkFile(path, file).then(is_exist => {
              File.readAsArrayBuffer(path, file).then(res => {
                this.record_file[file] = new Blob([res]);
                File.removeFile(path, file);
              })
            }).catch(err => {
              console.log(err)
            })
          } catch (e) {
            console.log(e)
          }
        }
      }

      // 如果能獨自閱讀，後面則顯示詞語點選，如果不能閱讀，則顯示單個詞語
      if (this.questions[this.current_question_index]['resource_id'] === 4) {
        let index = 0;
        if (this.current_answer === 1) {
          this.setLiterate(true);
          index = this.questions.findIndex(function (item) {
            return item.resource_id === 12;
          })
        } else {
          this.setLiterate(false);
          index = this.questions.findIndex(function (item) {
            return item.resource_id === 13;
          })
        }
        this.questions.splice(index, 1);
      }

      this.show_confirm_btn = false;
      this.current_question_index += 1;
      this.current_answer = null;
      this.showQuestion(this.current_question_index)
    },
    goTestFinish: async function () {
      const loading = common.showLoading();
      const deviceInfo = await Device.getInfo();
      const form_data = new window.FormData();
      form_data.append('user_id', this.user_info.id);
      form_data.append('test_id', this.test_id);
      form_data.append('answer', JSON.stringify(this.answers));

      for (const key in this.record_file) {
        form_data.append(key, this.record_file[key], key);
      }

      form_data.append('test_record', JSON.stringify(this.test_record));
      form_data.append('device_info', JSON.stringify({
        screen_resolution: window.screen.width * window.devicePixelRatio + '×' + window.screen.height * window.devicePixelRatio,
        device_model: deviceInfo.model,
        os_version: deviceInfo.osVersion
      }))

      common.apiPostData('/answerTestQuestion', form_data, true, loading).then(res => {
        if (res === false) {
          return false;
        }

        const storage_result = common.setStorage('result_' + this.user_info.id, res.result);
        const storage_test_id = common.setStorage('storage_test_id', this.test_id);
        Promise.all([storage_result, storage_test_id]).then(() =>
          router.replace('/testFinish')
        );
      })
    },
    debugAudio: function (message, extra = {}) {
      if (!this.isDebugMode) {
        return;
      }

      const audio = this.audio;
      console.info('[ECS audio]', message, {
        question_id: this.current_question_id,
        question_type: this.current_question_type,
        voice: audio ? audio.currentSrc || audio.src : this.current_voice,
        readyState: audio ? audio.readyState : undefined,
        networkState: audio ? audio.networkState : undefined,
        paused: audio ? audio.paused : undefined,
        currentTime: audio ? audio.currentTime : undefined,
        duration: audio ? audio.duration : undefined,
        ...extra,
      });
    },
    getPageAudio: function () {
      if (!this.audio) {
        this.audio = document.querySelector('#audio');
      }

      return this.audio;
    },
    removeAudioListeners: function () {
      if (!this.audio) {
        this.audioEndedHandler = null;
        this.audioErrorHandler = null;
        return;
      }

      if (this.audioEndedHandler) {
        this.audio.removeEventListener('ended', this.audioEndedHandler);
        this.audioEndedHandler = null;
      }

      if (this.audioErrorHandler) {
        this.audio.removeEventListener('error', this.audioErrorHandler);
        this.audioErrorHandler = null;
      }
    },
    stopAudioPlayback: function (reset_src = true) {
      this.audioPlaybackId++;

      if (this.play_timeout) {
        clearTimeout(this.play_timeout);
        this.play_timeout = null;
      }

      if (!this.audio) {
        this.audio = document.querySelector('#audio');
      }

      this.removeAudioListeners();

      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        if (reset_src) {
          this.audio.removeAttribute('src');
          this.audio.load();
        }
      }

      this.voice_play = false;
    },
    playAudio: async function (voice, onEnded = null, options = {}) {
      const audio = this.getPageAudio();
      const setVoicePlay = options.setVoicePlay !== false;

      if (!audio || !voice) {
        this.voice_play = false;
        this.debugAudio('audio element or voice missing', { voice });
        return false;
      }

      this.stopAudioPlayback(false);
      this.audio = audio;
      const playbackId = ++this.audioPlaybackId;

      if (setVoicePlay) {
        this.voice_play = true;
      }

      this.audioEndedHandler = async () => {
        if (playbackId !== this.audioPlaybackId) {
          return;
        }

        this.debugAudio('ended');
        this.removeAudioListeners();
        if (onEnded) {
          await onEnded();
        }
      };

      this.audioErrorHandler = () => {
        if (playbackId !== this.audioPlaybackId) {
          return;
        }

        const error = audio.error ? {
          code: audio.error.code,
          message: audio.error.message,
        } : null;
        this.debugAudio('error', { error });
        this.voice_play = false;
        this.removeAudioListeners();
      };

      if (onEnded) {
        audio.addEventListener('ended', this.audioEndedHandler, { once: true });
      }
      audio.addEventListener('error', this.audioErrorHandler, { once: true });

      audio.src = voice;
      audio.load();

      try {
        this.debugAudio('play start', { voice });
        const playPromise = audio.play();
        if (playPromise && typeof playPromise.then === 'function') {
          await playPromise;
        }
        if (playbackId !== this.audioPlaybackId) {
          return false;
        }
        this.debugAudio('play resolved', { voice });
        return true;
      } catch (error) {
        if (playbackId !== this.audioPlaybackId) {
          return false;
        }

        this.debugAudio('play rejected', {
          name: error ? error.name : undefined,
          message: error ? error.message : undefined,
        });
        this.voice_play = false;
        this.removeAudioListeners();
        audio.pause();
        return false;
      }
    },

    playVoice: function () {
      if (this.play_timeout) {
        return;
      }

      this.stopAudioPlayback(false);
      // if (!this.show_confirm_btn) {
      //   this.show_confirm_btn = false;
      // }
      if (this.current_question_type === 1009 && this.current_word_index > 0) {
        this.current_word_index = 0;
      }
      this.show_confirm_btn = false;

      if (this.current_question_type === 1010) {
        this.confirm_tips_text = this.confirm_tips[1];
        this.story_confirm_tips_show = true;
      }

      this.voice_play = true;
      this.play_timeout = setTimeout(async () => {
        if (!this.play_timeout) return;

        this.play_timeout = null;
        await this.playAudio(this.current_voice, this.handleEnded);
      }, 1000);
    },
    handleEnded: async function () {
      this.voice_play = false;
      if (this.current_question_type === 1001 || this.current_question_type === 1003 || this.current_question_type === 1005 ) {
        this.showConfirmBtn();
      }
      if (this.current_question_type === 1010) {
        this.nextQuestion();
      }
      if (this.current_question_type === 1009) {
        this.playWordOption();
      }
      if (this.current_question_type === 1005) {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        const second = String(date.getSeconds()).padStart(2, '0');
        const ms = String(date.getMilliseconds()).padStart(3, '0');

        if (!isPlatform('hybrid')) {
          // 浏览器端：先启动录音，根据实际格式设置扩展名
          await this.startRecordWeb();
          const mimeType = this.mediaRecorder?.mimeType || '';
          let extension = '.webm';
          if (mimeType.includes('mp4')) {
            extension = '.m4a'; // MP4 音频使用 .m4a 扩展名
          } else if (mimeType.includes('webm')) {
            extension = '.webm';
          }
          this.current_answer = `record_${year}${month}${day}${hour}${minute}${second}${ms}_${this.test_id}${extension}`;
        } else {
          // App 端统一使用 m4a
          this.current_answer = `record_${year}${month}${day}${hour}${minute}${second}${ms}_${this.test_id}.m4a`;
          this.media = Media.create(this.current_answer);
          this.media.startRecord();
        }
      }

      // 开始计算回答時間
      this.startTime = performance.now();
      // console.log(`开始时间: ${this.startTime} 毫秒`);

      this.removeAudioListeners();
    },
    debugFastForwardAudio: async function () {
      if (!this.isDebugMode || !this.voice_play) {
        return;
      }

      const question = this.questions ? this.questions[this.current_question_index] : null;
      console.info('[ECS debug] fast forward audio', {
        id: question ? question.id : this.current_question_id,
        type: question ? question.type : this.current_question_type,
        resource_id: question ? question.resource_id : undefined,
        answer: this.current_answer,
      });

      this.stopAudioPlayback(false);

      if (question && question.type === 1004) {
        this.voice_play = false;
        this.initConfirmTips();
        await this.nextQuestion();
        return;
      }

      await this.handleEnded();
    },
    playWord: function () {
      let index = 0;
      this.confirm_tips_text = this.confirm_tips[1];
      this.voice_play = true;
      this.words_confirm_tips_show = true;

      const playNext = async () => {
        if (this.words_voice[index] === undefined) {
          this.nextQuestion();
          this.initConfirmTips();
          return;
        }

        await this.playAudio(this.words_voice[index], () => {
          index++;
          setTimeout(playNext, 500);
        });
      };

      playNext();
    },
    getWordVoice: function (value) {
      for (const i in this.words) {
        if (this.words[i].id == value) {
          return common.getVoice(this.words[i].resource_id)
        }
      }
    },
    showConfirmBtn: function () {
      this.show_confirm_btn = true;
      this.record_confirm_ready_time = this.getCurrentTime();
    },
    hideConfirmBtn: function () {
      this.show_confirm_btn = false;
    },
    disableClockScroll: function () {
      this.clock_scroll_enabled = false;
    },
    enableClockScroll: function () {
      this.clock_scroll_enabled = true;
    },
    moveClock: function () {
      this.showConfirmBtn();
    },
    selectStoryOption: function () {
      this.showConfirmBtn();
    },
    selectWordOption: function (is_selected, values) {
      if (is_selected) {
        this.showConfirmBtn();
      } else {
        this.hideConfirmBtn();
      }
    },
    initConfirmTips: function () {
      this.confirm_tips_text = this.confirm_tips[0];
    },
    playWordOption: function () {
      this.stopAudioPlayback(false);
      const current_word = this.words_option[this.current_word_index];
      const voice = common.getVoice(current_word.resource_id);
      this.current_word_item = current_word.item;

      this.playAudio(voice, null, { setVoicePlay: false });
    },
    nextWordOption: function () {
      for (const i in this.record_action_sequence) {
        this.record_action_sequence[i].seq = parseInt(i) + 1;
        // if (!this.record_action_sequence[i].confirm) {
        //   this.record_action_sequence[i].word = this.record_action_sequence[i].word ? this.record_action_sequence[i].word : this.current_word_item
        // }
      }

      this.addConfirmRecord();

      if (this.current_word_index >= 11) {
        this.nextQuestion(true)
        return;
      }

      this.stopAudioPlayback(false);

      this.current_word_index++;
      this.hideConfirmBtn()
      this.$refs.word_tick.initData();
      this.playWordOption()

    },
    getAnswer: function (answer) {
      this.current_answer = answer;
    },
    getWordAnswer: function (answer) {
      if (this.current_answer == null) {
        this.current_answer = {};
      }
      this.current_answer[this.words_option[this.current_word_index].id] = answer;
    },
    goBack: function () {
      this.addTestRecord('go_back', '', true);

      if (this.current_question_time_inter) {
        clearInterval(this.current_question_time_inter);
      }

      this.current_question_index -= 1
      const question = this.questions[this.current_question_index];
      if (this.checkHasAnswer(question.type)) {
        this.answers.pop();
      }

      this.show_confirm_btn = false;
      this.current_question_time = 0;
      this.current_word_index = 0;
      this.current_answer = null;
      this.showQuestion(this.current_question_index);
      if (this.current_question_index === 0) {
        this.show_back_button = false;
      }
    },
    checkHasAnswer: function (type) {
      return type !== 1001 && type !== 1003 && type !== 1010;
    },
    stopRecord: function () {
      // 暫停錄音
      if (this.media) {
        this.media.stopRecord();
        this.media = null;
      }
    },
    startRecordWeb: async function () {
      const TIMESLICE_MS = 1000;
      const MAX_CHUNKS = 5 * 60; // 5分鐘 × 每秒1個chunk

      try {
        const stream = await requestMicrophoneStream();

        if (!stream) {
          throw new Error('瀏覽器不支援麥克風錄音');
        }

        // 设置录音格式：优先使用 WebM (Opus)
        let options = {};
        if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
          options = { mimeType: 'audio/webm;codecs=opus' };
        } else if (MediaRecorder.isTypeSupported('audio/webm')) {
          options = { mimeType: 'audio/webm' };
        } else if (MediaRecorder.isTypeSupported('audio/mp4')) {
          options = { mimeType: 'audio/mp4' };
        }

        this.mediaRecorder = new MediaRecorder(stream, options);
        this.audioChunks = [];
        this.recordStartTime = Date.now();

        this.mediaRecorder.ondataavailable = (event) => {
          if (this.audioChunks.length >= MAX_CHUNKS) {
            // 已達5分鐘，停止錄音但等待用戶手動確認（只觸發一次）
            if (this.mediaRecorder) {
              this.stopRecordWeb().then(audioBlob => {
                if (audioBlob) this.record_file[this.current_answer] = audioBlob;
              });
            }
            return;
          }
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.start(TIMESLICE_MS);
      } catch (error) {
        console.error('瀏覽器錄音失敗:', error);
        common.showAlert('無法訪問麥克風，請檢查瀏覽器權限設置')
      }
    },
    stopRecordWeb: function () {
      return new Promise((resolve) => {
        if (!this.mediaRecorder) {
          resolve(null);
          return;
        }

        // 保存 mimeType，因为 stop 后 mediaRecorder 会被设为 null
        const mimeType = this.mediaRecorder.mimeType || 'audio/webm';

        this.mediaRecorder.onstop = () => {
          // 截取最多5分鐘的chunks（應對後台積壓數據）
          const MAX_CHUNKS = 5 * 60;
          const chunks = this.audioChunks.slice(0, MAX_CHUNKS);
          this.audioChunks = [];
          const audioBlob = new Blob(chunks, { type: mimeType });
          resolve(audioBlob);
        };

        this.mediaRecorder.stop();
        this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
        this.mediaRecorder = null;
      });
    },
    handleVisibilityChange: function () {
      if (document.visibilityState === 'visible' && this.mediaRecorder) {
        if (Date.now() - this.recordStartTime > 5 * 60 * 1000) {
          this.stopRecordWeb().then(audioBlob => {
            if (audioBlob) this.record_file[this.current_answer] = audioBlob;
          });
        }
      }
    },
    setLiterate: function (is_literate) {
      common.setStorage('is_literate_' + this.user_info.id, is_literate);
    },
    confirmLeave: function (e) {
      e.preventDefault();
      e.returnValue = '';
    },
    initialRecordTime: function () {
      return new Date().getTime();
    },
    getCurrentTime: function () {
      return (new Date().getTime() - this.record_initial_time) / 1000;
    },
    addTestRecord: function (record_type, answer_value = '', is_back = false) {
      this.test_record.push({
        test_id: this.test_id,
        question_id: this.current_question_id,
        record_type: record_type,
        answer_value: answer_value,
        question_start_time: !is_back ? this.record_question_start_time : '',
        question_end_time: !is_back ? this.getCurrentTime() : '',
        confirm_ready_time: !is_back ? this.record_confirm_ready_time : '',
        confirm_input_time: !is_back && this.record_confirm_ready_time ? this.getCurrentTime() : '',
        confirm_coordinate: !is_back ? this.record_confirm_coordinate : '',
        action_sequence: !is_back ? this.record_action_sequence : '',
      })

      this.clearActionSequence();
      this.record_confirm_ready_time = '';
      this.record_confirm_coordinate = '';
    },
    clearActionSequence: function () {
      this.record_action_sequence = [];
    },
    addActionSequence: function (data = {}) {
      this.record_action_sequence.push(data);
    },
    addConfirmRecord: function () {
      this.record_action_sequence.push({
        seq: this.record_action_sequence.length + 1,
        x: event.x * window.devicePixelRatio,
        y: event.y * window.devicePixelRatio,
        input_time: common.getTestRecordTime(this.record_initial_time),
        confirm: 'confirm',
      })
    }
  }

}
</script>

<style scoped>
  .test-box{
    width: 100%;
    margin: 0 auto;
    padding: 0;
    /* padding-bottom: clamp(4rem, 9vw, 6rem); */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: calc(100dvh - clamp(1rem, 4vw, 2.5rem));
  }
  .content {
    --overflow: auto;
    overflow: auto;
    --padding-top: 1rem;
    --padding-bottom: 1rem;
  }
  .trumpet, .hear, .mic{
    width: clamp(5.5rem, 14vw, 9rem);
  }
  .quizNumber{
    text-align: center;
  }

  .img-box{
    display: flex;
    justify-content: center;
    margin: clamp(1rem, 3vw, 2rem) auto 0;
  }

  .debug-fast-forward {
    position: fixed;
    right: calc(env(safe-area-inset-right) + 0.75rem);
    top: calc(env(safe-area-inset-top) + 6.25rem);
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: clamp(2.75rem, 6vw, 3.5rem);
    height: clamp(2rem, 4vw, 3rem);
    padding: 0 clamp(0.625rem, 1.5vw, 0.875rem);
    border: 0;
    border-radius: 999px;
    background: rgba(96, 96, 96, 0.86);
    color: white;
    font-size: var(--ecs-font-md);
    line-height: 1.2;
    font-weight: 700;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    cursor: pointer;
  }

  .test-confirm-button :deep(.relative){
    margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
  }

  .trumpet, .hear, .mic, .tick{
    position: relative;
  }

  @media (orientation: landscape) and (max-height: 480px) {
    .test-box{
      width: 100%;
      margin: 0 auto;
      /* padding: 0 0 clamp(2.5rem, 6vw, 4rem); */
      min-height: calc(100dvh - clamp(1rem, 4vw, 2.5rem));
    }

    .trumpet, .hear, .mic{
      width: clamp(4.5rem, 11vw, 6.5rem);
    }

    .img-box{
      margin-top: clamp(0.75rem, 2vw, 1.25rem);
    }
  }
</style>
